<template>
	<div class="cnt-contract-activation">
		<header>
			<div class="container">
				<h1>
					<b> Ativação de contrato Viamed </b>
					<small>
						Por favor, leia as seguintes informações importantes
						antes de continuar
					</small>
				</h1>
			</div>
		</header>
		<main class="content-msg-load" v-if="load_error">
			<i class="fa fa-warning"></i>
			<h3 class="msg-load text-center">
				Ops <br />
				<small
					>Infelizmente não conseguiremos <br />
					ativar seu contrato agora</small
				>
			</h3>
		</main>
		<main v-else-if="!!request && !load_error">
			<template v-if="!is_actived">
				<div class="container">
					<h3>Contrato</h3>
					<div class="cnt-contract" v-html="htmlDoc"></div>
					<label class="checkbox">
						<input type="checkbox" v-model="actions.read" />
						Li e concordo com os termos do contrato.
					</label>
					<label class="checkbox">
						<input type="checkbox" v-model="actions.sendMail" />
						Desejo receber uma cópia desse contrato em meu email.
						<br />
						<small>{{ clientMail }}</small>
					</label>
					<div class="text-right">
						<button
							class="btn btn-warning btn-lg"
							:disabled="!actions.read"
							@click="sendActivation"
						>
							Ativar contrato
						</button>
					</div>
					<br />
				</div>
			</template>
			<template v-else>
				<div class="container cnt-msg-accert">
					<svg
						class="icon-happy"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 496 512"
					>
						<path
							fill="currentColor"
							d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6C68.8 359.6 48 309.4 48 256s20.8-103.6 58.6-141.4C144.4 76.8 194.6 56 248 56s103.6 20.8 141.4 58.6c37.8 37.8 58.6 88 58.6 141.4s-20.8 103.6-58.6 141.4zM328 164c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1zm-160 60c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
						></path>
					</svg>
					<div class="cnt-msg">
						<h3>Contrato ativo</h3>
						<div class="cnt-msg-client" v-html="msgClient"></div>
						<br />
						<button class="btn btn-warning">Ver o contrato</button>
					</div>
				</div>
			</template>
		</main>
		<main class="content-msg-load" v-else>
			<i class="fa fa-spin fa-spinner"></i>
			<h3 class="msg-load">Carregando...</h3>
		</main>
	</div>
</template>
<script>
	import toastr from 'toastr';
	import browser from 'browser-detect';
	import moment from 'moment';

	export default {
		data() {
			return {
				request: null,
				load_error: false,
				actions: {
					read: false,
					sendMail: false,
				},
			};
		},
		methods: {
			sendActivation() {
				const sData = {
					action: this.actions,
					document: this.request.buildContract.PDF,
					document_real: this.request.buildContract.PDF_FOLDER,
					contract_id: this.request.contract.cod,
					datetime: new Date(),
					email: this.clientMail,
				};

				this.$wbs.send(
					'public-save-activationContract',
					sData,
					(resp) => {
						this.request.contract.xActivation = resp.data;
					}
				);
			},
		},
		computed: {
			msgClient() {
				try {
					moment.locale('pt-br');
					const {
						cod,
						xActivation: { agent, date, ip },
						cod_proposta: {
							cnpj: { razao_social },
						},
					} = this.request.contract;

					console.log(this.request.contract);

					const { name, os } = browser(agent);
					const time = moment(date, 'DD/MM/YYYY HH:mm:ss').calendar();

					return (
						`<h2>Olá ${razao_social}</h2>` +
						`Seu contrato número <b>${cod}</b> já está <b>ativo</b> em nosso sistema.<br>` +
						`O mesmo foi ativo na <b>${time}</b> no ip <b>${ip}</b> <br>` +
						`O senhor estava em um computador com <b>${os}</b> e usou o <b>${name}</b>`
					);
				} catch (error) {
					console.log(error);
					return 'Erro inesperado...';
				}
			},
			htmlDoc() {
				return window.atob(this.request.doc);
			},
			clientMail() {
				const mail =
					this.request.contract.cod_proposta.cnpj.contatos[
						this.request.contract.cod_proposta.cnpj.contato
					];
				if (!mail) return '';
				return mail.mail;
			},
			is_actived() {
				return !Array.isArray(this.request.contract.xActivation);
			},
		},
		mounted() {
			this.$wbs.send(
				'public-read-contractInformation',
				{ id: this.$route.params.id },
				(resp) => {
					if (resp.status == 'success') {
						this.request = resp.data;
					} else if (resp.status == 'error') {
						this.load_error = true;
						resp.msgs.forEach((item) => {
							toastr.error(item);
						});
					}
				}
			);
		},
	};
</script>
<style scoped>
	.cnt-msg {
		margin-left: 55px;
	}
	.cnt-msg-accert {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.icon-happy {
		width: 130px;
		color: #fc561c;
	}
	.content-msg-load {
		height: calc(100vh - 172px);
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.msg-load {
		font-size: 30px;
	}
	.fa.fa-spin.fa-spinner {
		font-size: 126px;
		color: #fc561c;
	}
	.fa.fa-warning {
		font-size: 126px;
		color: red;
	}
	.checkbox small {
		color: #a2a2a2;
		font-size: 14px;
		font-style: italic;
	}
	.checkbox {
		font-weight: 400;
		padding-left: 21px;
	}
	.container {
		width: 21cm;
		margin: 0 auto;
	}
	.cnt-contract {
		padding: 7em 3em;
		background: #fff;

		height: 500px;
		overflow: auto;
		border-radius: 8px;
		border: 1px solid #cecece;
	}
	.cnt-contract-activation {
		background-color: #ecf0f5;
		min-height: 100vh;
	}

	header {
		background: #fc561c;
		color: #fff;
		text-align: center;
		padding: 30px 0 40px;
		margin-bottom: 20px;
	}
	header h1 b {
		text-transform: uppercase;
		letter-spacing: 2px;
		font-size: 30px;
		padding-bottom: 5px;
		display: block;
	}
	header h1 small {
		display: block;
		color: rgba(255, 255, 255, 0.75);
		font-size: 14px;
		font-weight: 100;
		letter-spacing: 1px;
	}
</style>



// WEBPACK FOOTER //
// src/components/contract-activation/index.vue